import { AppointmentRequestItem } from './syncAppointmentRequest.model';

export class RescheduleAppointmentRequest {
    public rescheduleGuid?: string;
    public daySmartAccountID: string;
    public startDateTime: string;
    public endDateTime: string;
    public lastModifiedDateTime: Date;
    public itemList: AppointmentRequestItem[];
    public comments?: string;

    constructor(
        daySmartAccountID: string,
        startDateTime: string,
        endDateTime: string,
        lastModifiedDateTime: Date,
        itemList: AppointmentRequestItem[],
        comments?: string,
        rescheduleGuid?: string
    ) {
        this.rescheduleGuid = rescheduleGuid;
        this.daySmartAccountID = daySmartAccountID;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        this.lastModifiedDateTime = lastModifiedDateTime;
        this.itemList = itemList;
        this.comments = comments;
    }
}
